import { render, staticRenderFns } from "./AddComm.vue?vue&type=template&id=f4d83fe2&scoped=true"
import script from "./AddComm.vue?vue&type=script&lang=js"
export * from "./AddComm.vue?vue&type=script&lang=js"
import style0 from "./AddComm.vue?vue&type=style&index=0&id=f4d83fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d83fe2",
  null
  
)

export default component.exports